import { socket } from "../index";

const emitGetMyInfo = () => {
  socket?.emit('GET_MYINFO');
}

export default emitGetMyInfo;